/* eslint-disable */
import Vue from 'vue'
import {
  Button,
  Card,
  Cascader,
  Checkbox,
  CheckboxGroup,
  Col,
  DatePicker,
  Dialog,
  Divider,
  Drawer,
  Form,
  FormItem,
  Image,
  Input,
  Loading,
  Message,
  MessageBox,
  Notification,
  Option,
  Pagination,
  Popover,
  Row,
  Select,
  TabPane,
  Tabs,
  Tag,
  Upload
} from 'element-ui'

Vue.use(Button)
Vue.use(Card)
Vue.use(Cascader)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Col)
Vue.use(DatePicker)
Vue.use(Dialog)
Vue.use(Divider)
Vue.use(Drawer)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Image)
Vue.use(Input)
Vue.use(Option)
Vue.use(Pagination)
Vue.use(Popover)
Vue.use(Row)
Vue.use(Select)
Vue.use(TabPane)
Vue.use(Tabs)
Vue.use(Tag)
Vue.use(Upload)

Vue.use(Loading.directive)
Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message

Vue.prototype.$ELEMENT = { size: 'small', zIndex: 3000 }
